module.exports = __webpack_public_path__ + "img/progress_bar_icon.59f6ad25.svg";